import { GithubOutlined } from '@ant-design/icons';
import { DefaultFooter } from '@ant-design/pro-components';
import React from 'react';

const Footer: React.FC = () => {
  return (
    <DefaultFooter
      copyright="Powered by FocusFilm"
      links={[
        {
          key: 'FocusMedia',
          title: 'FocusMedia',
          href: 'https://www.focusmedia.cn/',
          blankTarget: true,
        },
        // {
        //   key: 'github',
        //   title: <GithubOutlined />,
        //   href: 'https://github.com/ant-design/ant-design-pro',
        //   blankTarget: true,
        // },
        {
          key: 'FocusFilm',
          title: 'FocusFilm',
          href: 'https://www.focusmedia.cn/screen/#jump',
          blankTarget: true,
        },
      ]}
    />
  );
};

export default Footer;
